var exports = {
  "Jc": "x61f99309--d61e80--chatbot-button-container",
  "HY": "x61f99309--d61e80--chatbot-button",
  "xQ": "x61f99309--d61e80--chatbot-button--disabled",
  "HT": "x61f99309--d61e80--like-button",
  "Gq": "x61f99309--d61e80--tooltip-content",
  "oX": "x61f99309--d61e80--tooltip-image",
};

module.exports = exports;
